import { EntityReferences } from "../models/mappers";
import { EntityName } from "./entityNames";
import { AnyEntityField } from "./metadata";

export const ecommerceFields = [
  "gaming_ecommerceid", // UID
  "createdon", // Date
  "statecode", // Choice
  "statuscode", // Choice
  "gaming_name", // Text
  "gaming_address1_line1", // Text
  "gaming_address1_line2", // Text
  "gaming_address1_city", // Text
  "gaming_address1_stateorprovince", // Text
  "gaming_address1_postalcode", // Text
  "gaming_address1_telephone1", // Phone
  "gaming_locationtaxidtype", // Global Choice - gaming_taxidtype
  "ggp_vatid", // Text
  "ggp_taxidnumber", // Text
  "ggp_taxcertification", // Text
  "gaming_vatliable", // Boolean
  "gaming_chinesegoldenaddress", // Multiline Text
  "ggp_purchasingcustomertype", // Choice
  "ggp_xdkstoreaction", // Choice
  "ggp_xdkstorestatus", // Choice
  "gaming_xdkstoreactiontemp", // Choice
  "gaming_AccountId", // Lookup - Account
  "gaming_CountryId", // Lookup - Country/Region
  "gaming_FinancialContactId", // Lookup - Contact
  "gaming_HubLastUpdateByContactId", // Lookup - Contact
] as const;

export const ecommerceReferences: EntityReferences<EntityName.gaming_ecommerce> = {
  [EntityName.account]: ["gaming_AccountId"],
  [EntityName.ggp_country]: ["gaming_CountryId"],
  [EntityName.contact]: ["gaming_FinancialContactId", "gaming_HubLastUpdateByContactId"],
};

export const ecommerceKey: AnyEntityField<EntityName.gaming_ecommerce> = "gaming_ecommerceid";
